import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export default function LimeInstallRoute() {
  useBreadcrumb('routes/lime-install', 'Lime Install');
  return <PageLoader pageName="lime-install" />;
}
